<template>
  <section class="navTo">
    <router-link :to="link">
      <span>
        {{title}}
        <img src="/static/v2/match/view_all_tri.png" />
      </span>
    </router-link>
  </section>
</template>

<script>
export default {
  props: ["link", "title"]
};
</script>

<style lang="stylus" scoped>
.navTo {
  display: inline-block;

  a {
    span {
      display: inline-block;
      width: 60px;
      color: #0A0A0A;
      height: 20px;
      font-size: 14px;
      font-weight: 400;
      cursor: pointer;
      position: relative;
      margin-right: 12px;
      font-family: PingFang SC;

      &:hover {
        border-bottom: 1px solid #0A0A0A;
      }

      img {
        position: absolute;
        margin-top: 6px;
        width: 7px;
        height: 9px;
        right: -8px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/v2/NavTo.vue